// Nøkkel for lagring av visningsmodus i localStorage
export const STORAGE_KEY_VIEWMODE = 'sar61_program_view_mode';

// Hjelpefunksjoner for visningsmodus
export function getDefaultViewModeByViewport() {
    if (typeof window === 'undefined') return 'list';
    return window.matchMedia('(min-width: 1024px)').matches ? 'timeline' : 'list';
}

// Les lagret visningsmodus fra localStorage
export function readStoredViewMode() {
    try {
        const v = localStorage.getItem(STORAGE_KEY_VIEWMODE);
        return v === 'list' || v === 'timeline' ? v : null;
    } catch (e) {
        return null;
    }
}

// Lagre visningsmodus i localStorage
export function storeViewMode(mode) {
    try {
        localStorage.setItem(STORAGE_KEY_VIEWMODE, mode);
    } catch (e) {
        // ignore
    }
}
